import { startTime } from '@mailonline/dmg-ads-core/src/startTime'
import messageBus from '@mailonline/dmg-ads-core/src/ads-utils/MessageBus'
import { last } from "@mailonline/dmg-ads-core/src/ads-utils/ArrayUtils";
import device from './device'
import packageInfo from '../../package.json'

const broker = messageBus.broker('ANAdsAPI')

function getAdContainer(ad) {
  const scriptTag = document.currentScript ||
    last(document.querySelectorAll(`*[id^=${ad.pos}] script`)) ||
    last(document.scripts)

  return scriptTag?.parentNode
}

const addToArray = ad => {
  const { id: containerId } = getAdContainer(ad) || {}
  const slot = { ...ad, containerId }
  broker.emit('api message', 'adSlotMount', slot)
}

global.adverts = global.adverts || {}
global.adverts.queue = global.adverts.queue || []
global.adverts.addToArray = addToArray
global.DM = global.DM || {}
global.__dmgCmp = global.__dmgCmp || []
global.pagemeta = global.pagemeta || {}
global.pagemeta.adsBundleVersion = packageInfo.version.toString()

window.DM.later = function (str, func) {
  func();
};

window.adverts.startTime = startTime

window.adverts.stopRefreshingAds = (opts) => {
  broker.emit('stop refreshing ads', opts)
}

global.MobileUtils = {
  isMobile: function() {
    return device === 'mobile'
  }
}

const getVideoAdTag = async (opts) => {
  const videoArgs = { autoplay: false, offset: 0, pos: 'metro.video.chromeless', ...opts }

  const { adTagUrl } = await broker.invoke('get video ad tag', videoArgs)

  return adTagUrl
}

global.adverts.getVideoAdTag = getVideoAdTag
